import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { OfficeService } from '../../services/office.service';
import { Office } from '../../Models/Office';
import { HttpResponseModel } from '../../@core/common/models/HttpResponseModel';
@Component({
  selector: 'ngx-register',
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {

  registerForm: FormGroup;
  loading = false;
  submitted = false;
  returnlUrl: string;
  error = '';
  viewModel = {
    btnLoginCasplock: false,
    caspLockEnable: false,
    ListMenuDynamic: [],
  };
  entail = '@fsoft.com.vn';
  officeList: Office[];
  constructor(private formBuilder: FormBuilder,
    private rotue: Router,
    private authenticationService: AuthenticationService,
    private officeService: OfficeService) {

  }

  ngOnInit() {
    this.loading = true;
    this.getAllOfficeActive();
    this.registerForm = this.formBuilder.group({
      userName: ['', Validators.required],
      firstName: ['', Validators.required],
      midleName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('(0[1-9])+([0-9]{8})')])],
      officeId: ['', Validators.required],
    });
  }
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.loading = true;
    this.authenticationService.register(this.f.userName.value, this.f.firstName.value,
      this.f.midleName.value, this.f.lastName.value, this.f.officeId.value, this.f.phone.value)
      .subscribe(data => {
        if (data.Success === true) {
          this.loading = false;
          alert(data.Message);
          this.rotue.navigate(['/login']);
        }
      },
        error => {
          // this.spinner.hide();
          this.error = error;
          this.loading = false;
        });

  }
  getAllOfficeActive() {
    this.officeService.getActiveOffice().
      subscribe((data: HttpResponseModel<any>) => {
        if (data.Success) {
          this.officeList = data.Data;
          this.loading = false;
        }
        // tslint:disable-next-line: one-line
        else{
          this.officeList = null;
          this.loading = false;
        }
      },
        error => {
          // this.spinner.hide();
          this.error = error;
          this.loading = false;
        });
  }

}
